/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { partnerJoinRequestControllerApproveJoinRequest } from '../fn/partner-join-request/partner-join-request-controller-approve-join-request';
import { PartnerJoinRequestControllerApproveJoinRequest$Params } from '../fn/partner-join-request/partner-join-request-controller-approve-join-request';
import { partnerJoinRequestControllerCancelJoinRequest } from '../fn/partner-join-request/partner-join-request-controller-cancel-join-request';
import { PartnerJoinRequestControllerCancelJoinRequest$Params } from '../fn/partner-join-request/partner-join-request-controller-cancel-join-request';
import { partnerJoinRequestControllerCreate } from '../fn/partner-join-request/partner-join-request-controller-create';
import { PartnerJoinRequestControllerCreate$Params } from '../fn/partner-join-request/partner-join-request-controller-create';
import { partnerJoinRequestControllerFindAll } from '../fn/partner-join-request/partner-join-request-controller-find-all';
import { PartnerJoinRequestControllerFindAll$Params } from '../fn/partner-join-request/partner-join-request-controller-find-all';
import { partnerJoinRequestControllerFindById } from '../fn/partner-join-request/partner-join-request-controller-find-by-id';
import { PartnerJoinRequestControllerFindById$Params } from '../fn/partner-join-request/partner-join-request-controller-find-by-id';
import { partnerJoinRequestControllerRejectJoinRequest } from '../fn/partner-join-request/partner-join-request-controller-reject-join-request';
import { PartnerJoinRequestControllerRejectJoinRequest$Params } from '../fn/partner-join-request/partner-join-request-controller-reject-join-request';
import { partnerJoinRequestControllerSearchCursor } from '../fn/partner-join-request/partner-join-request-controller-search-cursor';
import { PartnerJoinRequestControllerSearchCursor$Params } from '../fn/partner-join-request/partner-join-request-controller-search-cursor';
import { partnerJoinRequestControllerSearchOffset } from '../fn/partner-join-request/partner-join-request-controller-search-offset';
import { PartnerJoinRequestControllerSearchOffset$Params } from '../fn/partner-join-request/partner-join-request-controller-search-offset';
import { PartnerJoinRequestDto } from '../models/partner-join-request-dto';

@Injectable({ providedIn: 'root' })
export class PartnerJoinRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `partnerJoinRequestControllerFindAll()` */
  static readonly PartnerJoinRequestControllerFindAllPath = '/api/partner-join-request';

  /**
   * 파트너사 승인 요청 전체 조회.
   *
   * 파트너사 승인 요청 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerFindAll$Response(params?: PartnerJoinRequestControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerJoinRequestDto>>> {
    return partnerJoinRequestControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 승인 요청 전체 조회.
   *
   * 파트너사 승인 요청 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerFindAll(params?: PartnerJoinRequestControllerFindAll$Params, context?: HttpContext): Observable<Array<PartnerJoinRequestDto>> {
    return this.partnerJoinRequestControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PartnerJoinRequestDto>>): Array<PartnerJoinRequestDto> => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerCreate()` */
  static readonly PartnerJoinRequestControllerCreatePath = '/api/partner-join-request';

  /**
   * 파트너사 승인 요청 생성.
   *
   * 파트너사 승인 요청을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerJoinRequestControllerCreate$Response(params: PartnerJoinRequestControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
    return partnerJoinRequestControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 승인 요청 생성.
   *
   * 파트너사 승인 요청을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerJoinRequestControllerCreate(params: PartnerJoinRequestControllerCreate$Params, context?: HttpContext): Observable<PartnerJoinRequestDto> {
    return this.partnerJoinRequestControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerJoinRequestDto>): PartnerJoinRequestDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerSearchOffset()` */
  static readonly PartnerJoinRequestControllerSearchOffsetPath = '/api/partner-join-request/search/offset';

  /**
   * 파트너사 승인 요청 오프셋 기반 조회.
   *
   * 파트너사 승인 요청을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerSearchOffset$Response(params: PartnerJoinRequestControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return partnerJoinRequestControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 승인 요청 오프셋 기반 조회.
   *
   * 파트너사 승인 요청을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerSearchOffset(params: PartnerJoinRequestControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.partnerJoinRequestControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerSearchCursor()` */
  static readonly PartnerJoinRequestControllerSearchCursorPath = '/api/partner-join-request/search/cursor';

  /**
   * 파트너사 승인 요청 커서 기반 조회.
   *
   * 파트너사 승인 요청을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerSearchCursor$Response(params: PartnerJoinRequestControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return partnerJoinRequestControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 승인 요청 커서 기반 조회.
   *
   * 파트너사 승인 요청을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerSearchCursor(params: PartnerJoinRequestControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.partnerJoinRequestControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerFindById()` */
  static readonly PartnerJoinRequestControllerFindByIdPath = '/api/partner-join-request/{id}';

  /**
   * 파트너사 승인 요청 ID 기반 조회.
   *
   * 파트너사 승인 요청을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerFindById$Response(params: PartnerJoinRequestControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
    return partnerJoinRequestControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 승인 요청 ID 기반 조회.
   *
   * 파트너사 승인 요청을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerFindById(params: PartnerJoinRequestControllerFindById$Params, context?: HttpContext): Observable<PartnerJoinRequestDto> {
    return this.partnerJoinRequestControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerJoinRequestDto>): PartnerJoinRequestDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerApproveJoinRequest()` */
  static readonly PartnerJoinRequestControllerApproveJoinRequestPath = '/api/partner-join-request/{id}/join/{joinId}/approve';

  /**
   * 파트너사 요청 승인.
   *
   * 파트너사 요청을 승인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerApproveJoinRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerJoinRequestControllerApproveJoinRequest$Response(params: PartnerJoinRequestControllerApproveJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
    return partnerJoinRequestControllerApproveJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 요청 승인.
   *
   * 파트너사 요청을 승인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerApproveJoinRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerJoinRequestControllerApproveJoinRequest(params: PartnerJoinRequestControllerApproveJoinRequest$Params, context?: HttpContext): Observable<PartnerJoinRequestDto> {
    return this.partnerJoinRequestControllerApproveJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerJoinRequestDto>): PartnerJoinRequestDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerRejectJoinRequest()` */
  static readonly PartnerJoinRequestControllerRejectJoinRequestPath = '/api/partner-join-request/{id}/join/{joinId}/reject';

  /**
   * 파트너사 요청 거부.
   *
   * 파트너사 요청을 거부합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerRejectJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerRejectJoinRequest$Response(params: PartnerJoinRequestControllerRejectJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
    return partnerJoinRequestControllerRejectJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 파트너사 요청 거부.
   *
   * 파트너사 요청을 거부합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerRejectJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerRejectJoinRequest(params: PartnerJoinRequestControllerRejectJoinRequest$Params, context?: HttpContext): Observable<PartnerJoinRequestDto> {
    return this.partnerJoinRequestControllerRejectJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerJoinRequestDto>): PartnerJoinRequestDto => r.body)
    );
  }

  /** Path part for operation `partnerJoinRequestControllerCancelJoinRequest()` */
  static readonly PartnerJoinRequestControllerCancelJoinRequestPath = '/api/partner-join-request/join/{id}/cancel';

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerJoinRequestControllerCancelJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerCancelJoinRequest$Response(params: PartnerJoinRequestControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
    return partnerJoinRequestControllerCancelJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerJoinRequestControllerCancelJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerJoinRequestControllerCancelJoinRequest(params: PartnerJoinRequestControllerCancelJoinRequest$Params, context?: HttpContext): Observable<PartnerJoinRequestDto> {
    return this.partnerJoinRequestControllerCancelJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerJoinRequestDto>): PartnerJoinRequestDto => r.body)
    );
  }

}
